// extracted by mini-css-extract-plugin
export default {"container":"DashboardPage_container__7gOvO","title":"DashboardPage_title__4MFSd","section":"DashboardPage_section__a+EWs","sectionLoading":"DashboardPage_sectionLoading__XS+1+"};